export const COUNTERS_GET = 'COUNTERS_GET';
export const CHANNEL_REPORT_GET = 'CHANNEL_REPORT_GET';
export const WEBTRACKING_INFOBOX_TOGGLE = 'WEBTRACKING_INFOBOX_TOGGLE';
export const CHANNEL_REPORT_OPTIONS_GET = 'CHANNEL_REPORT_OPTIONS_GET';
export const CHANNEL_REPORT_PERIOD_EDIT = 'CHANNEL_REPORT_PERIOD_EDIT';
export const BILLING_NAVIGATE = 'BILLING_NAVIGATE';
